import React from 'react';
import PropTypes from 'prop-types';

function Property({facet, property}) {
	if (!facet) {
		return null;
	}

	return (
		<span>
			{facet.properties[property].label}
		</span>
	);
}

Property.propTypes = {
	facet: PropTypes.object,
	property: PropTypes.number.isRequired,
};

export default React.memo(Property);
